import { Loader2, X } from "lucide-react";

const CURRENT_YEAR = new Date().getFullYear();

const ISSUE_TYPES = [
  { key: "lost_key", label: "Pérdida total de llave" },
  { key: "not_working", label: "Llave no funciona" },
  { key: "locked_inside", label: "Apertura (llaves dentro)" },
  { key: "key_copy", label: "Copia de llave" },
];

export const validateVehiclePrice = (f) => {
  if (!f.brand.trim() || !f.model.trim()) return "Marca y modelo son obligatorios";
  if (!f.issue_type) return "Selecciona un tipo de avería";
  const yf = Number(f.year_from), yt = Number(f.year_to);
  if (!Number.isInteger(yf) || !Number.isInteger(yt)) return "Los años deben ser enteros";
  if (yf < 1950 || yt > CURRENT_YEAR + 2) return `Años entre 1950 y ${CURRENT_YEAR + 2}`;
  if (yf > yt) return "'Año desde' no puede ser mayor que 'Año hasta'";
  if (Number(f.price) < 0) return "El precio no puede ser negativo";
  return null;
};

function Field({ label, children, testid }) {
  return (
    <label className="block" data-testid={testid}>
      <span className="block text-xs font-mono uppercase tracking-wider text-[#A1A1AA] mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export default function VehiclePriceEditor({ editing, setEditing, onSave, saving }) {
  if (!editing) return null;
  const cancel = () => setEditing(null);
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={cancel} data-testid="vp-editor-overlay">
      <div className="bg-[#0A0A0A] border border-white/10 rounded-md p-6 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <h4 className="font-display font-bold text-xl">{editing.id ? "Editar precio" : "Añadir precio"}</h4>
          <button onClick={cancel} className="text-[#71717A] hover:text-white p-1"><X className="w-4 h-4" /></button>
        </div>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Marca" testid="vp-form-brand">
              <input type="text" value={editing.brand} onChange={(e) => setEditing({ ...editing, brand: e.target.value })} className="vp-input" placeholder="Ej: Volkswagen" data-testid="vp-input-brand" />
            </Field>
            <Field label="Modelo" testid="vp-form-model">
              <input type="text" value={editing.model} onChange={(e) => setEditing({ ...editing, model: e.target.value })} className="vp-input" placeholder="Ej: Golf" data-testid="vp-input-model" />
            </Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Año desde" testid="vp-form-year-from">
              <input type="number" min="1950" max={CURRENT_YEAR + 2} value={editing.year_from} onChange={(e) => setEditing({ ...editing, year_from: e.target.value })} className="vp-input" data-testid="vp-input-year-from" />
            </Field>
            <Field label="Año hasta" testid="vp-form-year-to">
              <input type="number" min="1950" max={CURRENT_YEAR + 2} value={editing.year_to} onChange={(e) => setEditing({ ...editing, year_to: e.target.value })} className="vp-input" data-testid="vp-input-year-to" />
            </Field>
          </div>
          <Field label="Tipo de servicio" testid="vp-form-issue">
            <select value={editing.issue_type} onChange={(e) => setEditing({ ...editing, issue_type: e.target.value })} className="vp-input" data-testid="vp-input-issue">
              {ISSUE_TYPES.map((i) => <option key={i.key} value={i.key}>{i.label}</option>)}
            </select>
          </Field>
          <Field label="Precio (sin IVA, €)" testid="vp-form-price">
            <input type="number" step="0.01" min="0" value={editing.price} onChange={(e) => setEditing({ ...editing, price: e.target.value })} className="vp-input" data-testid="vp-input-price" />
          </Field>
        </div>
        <div className="flex gap-2 mt-6">
          <button onClick={cancel} className="btn-outline flex-1 px-4 py-2.5 rounded-md text-sm font-medium" data-testid="vp-cancel-btn">Cancelar</button>
          <button onClick={onSave} disabled={saving} className="btn-amber flex-1 px-4 py-2.5 rounded-md text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-40" data-testid="vp-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : (editing.id ? "Guardar cambios" : "Añadir")}
          </button>
        </div>
      </div>
    </div>
  );
}
